export default "__VITE_ASSET__7d164b27__"